import React from 'react';
import { motion } from 'framer-motion';

// 동의 체크 상자 모양 하나 — 회원가입 동의 칸(SignupConsentChecklist)과 후기 활용 동의(ReviewFormParts)가 같이 쓴다.
// 2026-10-28 대표 "라디오체크버튼 좀 디자인좀 제대로해줘" — 브라우저 기본 흰 네모 대신 사이트 동의 칸과 같은 모양으로 통일.
// 빈 상자는 검은 바탕에서도 보이게 테두리를 밝히고, 동그라미(라디오)로 안 보이게 모서리를 줄였다.
// 실제 체크는 바깥 <label> 안의 숨긴 <input type="checkbox">가 받는다(키보드·화면 읽기 프로그램 그대로).
export const ConsentBox: React.FC<{ checked: boolean }> = ({ checked }) => (
    <div
        className={`w-[22px] h-[22px] sm:w-6 sm:h-6 rounded-[7px] border-2 flex-shrink-0 transition-all duration-300 ${checked
            ? 'bg-[#00D87E] border-[#00D87E] shadow-[0_0_15px_rgba(0,216,126,0.3)]'
            : 'bg-transparent border-[#4A4A52] group-hover:border-[#8A8A93]'
            }`}
    >
        {checked && (
            <motion.svg initial={{ scale: 0 }} animate={{ scale: 1 }} className="w-full h-full text-white p-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12" />
            </motion.svg>
        )}
    </div>
);

export default ConsentBox;
